import { render, staticRenderFns } from "./RestorePasswordOrEmail.vue?vue&type=template&id=410cbe1a&scoped=true"
import script from "./RestorePasswordOrEmail.vue?vue&type=script&lang=js"
export * from "./RestorePasswordOrEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cbe1a",
  null
  
)

export default component.exports